var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionTypeBsGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2184 21.7501H7.28087C7.10683 21.7501 6.93991 21.6809 6.81684 21.5578C6.69376 21.4348 6.62462 21.2678 6.62462 21.0938V18.1251L4.3622 17.089C4.21271 17.0141 4.09746 16.8849 4.03998 16.7279C3.98251 16.5709 3.98714 16.3978 4.05294 16.2441L5.96837 12.5626C5.96837 11.4439 6.25431 10.3439 6.79904 9.36685C7.07768 8.86707 7.41931 8.40798 7.81393 8M17.1246 23.0626L16.4684 17.8126C17.3633 17.1414 18.0717 16.2526 18.5265 15.2306C18.9813 14.2086 19.1673 13.0873 19.0669 11.9732C18.9664 10.8591 18.5828 9.78917 17.9526 8.86501C17.6579 8.43299 17.314 8.03954 16.929 7.69189",
    stroke: "#575757",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 10H13.8125",
    stroke: "#575757",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7668 6.87106C10.4325 6.60988 10.1617 6.27632 9.97475 5.89545C9.78782 5.51458 9.68962 5.09631 9.68754 4.67204C9.67911 3.14767 10.9082 1.87888 12.4322 1.84372C13.0228 1.82941 13.603 2.00147 14.0903 2.33546C14.5776 2.66946 14.9474 3.14845 15.1472 3.70445C15.3469 4.26046 15.3665 4.86525 15.2032 5.43302C15.0398 6.0008 14.7018 6.50271 14.2371 6.86755C14.1346 6.94702 14.0516 7.04879 13.9942 7.16513C13.9369 7.28147 13.9068 7.40934 13.9063 7.53903V7.74997C13.9063 7.82456 13.8767 7.8961 13.8239 7.94884C13.7712 8.00159 13.6996 8.03122 13.625 8.03122H11.375C11.3005 8.03122 11.2289 8.00159 11.1762 7.94884C11.1234 7.8961 11.0938 7.82456 11.0938 7.74997V7.53903C11.0937 7.41016 11.0641 7.28302 11.0075 7.16728C10.9508 7.05153 10.8685 6.95022 10.7668 6.87106Z",
    stroke: "#575757",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionTypeBsGrey);
export default __webpack_public_path__ + "static/media/question_type_bs_grey.361b65abd340ee654a20ef760049d18f.svg";
export { ForwardRef as ReactComponent };